import { CALL_API, Schemas } from '../../../common/middleware/api';
import globalize from '../../../common/services/globalize';

export const CENTRALISED_ROYALTY_REPORT_REQUEST = 'CENTRALISED_ROYALTY_REPORT_REQUEST';
export const CENTRALISED_ROYALTY_REPORT_SUCCESS = 'CENTRALISED_ROYALTY_REPORT_SUCCESS';
export const CENTRALISED_ROYALTY_REPORT_FAILURE = 'CENTRALISED_ROYALTY_REPORT_FAILURE';

export const CENTRALISED_ROYALTY_EXPORT_REQUEST = 'CENTRALISED_ROYALTY_EXPORT_REQUEST';
export const CENTRALISED_ROYALTY_EXPORT_SUCCESS = 'CENTRALISED_ROYALTY_EXPORT_SUCCESS';
export const CENTRALISED_ROYALTY_EXPORT_FAILURE = 'CENTRALISED_ROYALTY_EXPORT_FAILURE';

export const loadRoyaltyReport = (options) => ({
	[CALL_API]: {
		types: [CENTRALISED_ROYALTY_REPORT_REQUEST, CENTRALISED_ROYALTY_REPORT_SUCCESS, CENTRALISED_ROYALTY_REPORT_FAILURE],
		endpoint: `api/reports/centralisedRoyalty`,
		request: options,
		schema: Schemas.CENTRALISED_ROYALTY_REPORT_ARRAY
	}
});

export const exportCentralisedRoyalty = (options, onSuccessEvent) => (dispatch, getState) => {
	dispatch({
		[CALL_API]: {
			types: [CENTRALISED_ROYALTY_EXPORT_REQUEST, CENTRALISED_ROYALTY_EXPORT_SUCCESS, CENTRALISED_ROYALTY_EXPORT_FAILURE],
			endpoint: `api/reports/centralisedRoyalty/export`,
			request: {
				...options,
				timeZone: globalize.getCurrentTimeZone(getState().configuration.franchisor)
			},
			onSuccessEvent
		},
		format: 'Excel',
		filename: () => `RoyaltyReport-${options.month}-${options.year}.xlsx`
	});
}